<template>
  <v-autocomplete
    :density="mobile == true ? 'compact': 'default'"
    class="input-busca"
    :class="mobile == true ? '' : 'input-height'"
    no-filter
    :items="products"
    item-title="name"
    item-value="name"
    :loading="isLoading"
    hide-no-data
    hide-selected
    hide-details
    menu
    menu-icon=""
    :menu-props="{ maxHeight: 400, contained: true, scrollStrategy: 'none' }"
    placeholder="Buscar por produto ou oferta"
    append-inner-icon="mdi-magnify"
    variant="outlined"
    v-model:search="search"
    @keydown.tab="buscaFocus = false"
    @keyup.enter="Buscar()"
    @focus="buscaFocus = true">
    <template v-slot:item="{ item }">
      <v-card class="border-0 pa-1">
        <v-card-item @click="Details(item.raw)" class="cursor-pointer" v-if="item.raw.sku != undefined">
          <v-row>
            <v-col cols="3" class="pa-0 d-flex">
              <v-img v-if="item.raw.image_thumb != '' && item.raw.image_thumb != null && item.raw.image_thumb != undefined && item.raw.image_thumb != 'no-image'" :src="item.raw.image_thumb"></v-img>
              <v-img v-else-if="item.raw.image_thumb == 'no-image'" src="@/assets/images/genericproduct.jpg"></v-img>
            </v-col>
            <v-col cols="9" class="d-flex flex-wrap align-center">
              <v-row no-gutters="">
                <v-col cols="12" class="d-flex align-end">
                  {{ item.raw.name }}
                </v-col>
                <v-col cols="12" class="d-flex align-end">
                  <b class="text-color-2 text-large" v-if="item.raw.offer != null && item.raw.offer.offer_connect > 0 && (item.raw.offer.amount_connect > 0 || item.raw.offer.is_offer_unlimited == 1)">{{ $formatNumber(item.raw.offer.offer_connect, {style: 'currency', currency: 'BRL'}) }}</b> 
                  <b class="text-color-1 text-large" v-else>{{ $formatNumber(item.raw.offer != null ? item.raw.offer.offer_price : item.raw.price, {style: 'currency', currency: 'BRL'}) }}</b> 

                  <span v-if="item.raw.offer != null && item.raw.offer.offer_connect > 0 && (item.raw.offer.amount_connect > 0 || item.raw.offer.is_offer_unlimited == 1)" class="bg-color-2 line-18 text-center ms-2 px-2 py-0 mb-1 text-white text-xsmall rounded">
                    <span v-if="item.raw.offer.is_offer_club == 1">Preço Clube</span>
                    <span v-else-if="item.raw.offer.is_offer_club == 0">Ative e Pague</span>
                  </span>
                  <span v-else-if="item.raw.offer != null && item.raw.offer.offer_connect == 0" class="bg-color-1 line-18 text-center ms-2 px-2 py-0 mb-1 text-white text-xsmall rounded">
                    <span>Oferta</span>
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-item>
        <v-card-item @click="BuscarClick(item.raw)" class="cursor-pointer" v-else>
          <span class="float-left">{{ item.raw }}</span>
          <template v-slot:append>
            <v-icon :icon="'mdi-close'" @click.stop="removeItemBusca(item.raw, $event)"></v-icon>
          </template>
        </v-card-item>
      </v-card>
    </template>
  </v-autocomplete>
  <div :class="buscaFocus == true ? 'buscar-backdrop' : ''" @click="buscaFocus = false"></div>
</template>

<script>
import ImageProduct from '@/components/ImageProduct.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'Search',
  components: {
    ImageProduct
  },
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      buscaFocus: false,
      isLoading: false,
      search: null,
      products: [],
      searchInterval: null
    }
  },
  computed: {
    ...mapGetters('buscas', ['getAllBuscas']),
  },
  watch: {
    'search': function(){
      //this.products = [];
      if(this.search.length >= 3){
        this.timeGetProducts();
      } else if(this.search.length > 0){
        this.loadSuggestions();
      }
    },
    'buscaFocus': function(){
      if(this.search == null || this.search.length <= 3){
        this.loadSuggestions();
      }
    }
  },
  methods: {
    ...mapActions('products', {
      buscaProdutosResume: 'buscaProdutosResume',
      getImageCarousel: 'getImageCarousel',
      addProduct: 'addProduct',
    }),
    ...mapActions('buscas', ['loadBuscas', 'removeBusca']),
    removeItemBusca(texto){
        this.removeBusca(texto);
        this.loadSuggestions();
    },
    loadSuggestions(){
      this.products = [];
      this.getAllBuscas.forEach(function(e){
        if(this.search != null && this.search != ''){
          if(e.nome.includes(this.search)){
            this.products.push(e.nome);
          }
        } else {
          this.products.push(e.nome);
        }
      }.bind(this));
    },
    Details(product){
      this.loadBuscas(this.search);
      this.search = "";
      this.buscaFocus = false;
      this.$router.push('/details/'+product.barcode);
    },
    BuscarClick(search){
      this.search = search;
      this.Buscar();
    },
    Buscar(){
      if(this.search.length >= 3){
        this.loadBuscas(this.search);
        this.buscaFocus = false;
        this.$router.push('/search/'+this.search);
        this.search = "";
      }
    },
    getProducts(){
      this.isLoading = true;
      clearInterval(this.searchInterval);
      this.buscaProdutosResume({ "name": this.search }).then(function(response){
        if(response != false){
          this.products = response;
          this.products.forEach(element => {
            this.getImageCarousel({ sku: element.sku, imghash: "t-"+element.imghash }).then(function(image){
              element.image_thumb = image;
            }.bind(this));
          });
        }
        this.isLoading = false;
      }.bind(this));
    },
    timeGetProducts(){
      if(this.searchInterval){
        clearInterval(this.searchInterval);
      }
      this.searchInterval = setInterval(() => {
        this.getProducts();
      }, 1000);
    },
  }
}
</script>